// extracted by mini-css-extract-plugin
module.exports = {"org-tree-box":"style_org-tree-box__2TMjg"};